import * as React from "react";
import { ChangeEvent } from "react";

import Field from "components/FormElements/Field";
import ToolTip from "components/ToolTip";

import MoneyInput from "./MoneyInput";

interface PropsType {
  error?: string;
  onChange(e: ChangeEvent<HTMLInputElement>): void;
  value: number | string;
}

export default function MonthlyPlanField(props: PropsType): JSX.Element {
  const { error, onChange, value } = props;

  return (
    <Field
      className="text"
      id="wage_schedule_amount_per_month"
      label="Monthly Plan Payment Amount"
      name="wage_schedule[amount_per_month]"
      toolTip={
        <ToolTip
          heading="Monthly Plan Payment Amount"
          content={`Please enter the total monthly plan payment
                      amount in this field. You can find this information on
                      the materials you received from the trusteeship.`}
        />
      }
      {...{ error, onChange }}
    >
      <MoneyInput {...{ value }} />
    </Field>
  );
}
